import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core'; // ElementRef is used to access the scroll container in GM and EZS
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ContentService } from 'src/app/base/services/content/content.service';
import { Page, PageParam } from 'src/app/base/interfaces/page';

import { environment } from '../../../environments/environment'
import { PageActionResponse } from 'src/app/base/interfaces/pageActionResponse';
import { first, Subject, switchMap, of, Observable, map, take, Subscription, interval, firstValueFrom } from 'rxjs';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../gigmonster/components/popup/popup.component';
import { AreyousureComponent } from '../../gigmonster/components/areyousure/areyousure.component';

import { AuthService } from 'src/app/base/services/auth/auth.service';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { I3VService } from 'src/app/base/services/i3v/i3v.service';
import { WorkflowService } from 'src/app/base/services/workflow/workflow.service';
import { AppComponent } from 'src/app/app.component';
import { AppidService } from 'src/app/base/services/appid/appid.service';
import { ThemeService } from '../services/theme/EZScssTheme.service';
import { ButtonService } from '../services/buttons/buttons.service';
@Component({
    selector: 'app-superstructure-base',
    template: ``,
    styles: []
})
export class SuperstructureBaseComponent implements OnInit {
    @Input() headerDropdownsReady: boolean = false;

    loadSideNavAndPageContent;

    appID: number;

    page: Page;
    pageID: number;
    navID: number;
    themeID: number;

    providedPageID: number;
    providedNavID: number;

    errorText = "";

    production: Boolean = environment.production;
    pageParams: PageParam[];

    reloadTableSubject: Subject<any> = new Subject<void>();
    reloadTableWithDataSubject: Subject<any> = new Subject<void>();

    // Loading animation for longer processes
    pageLoading: boolean = false;
    pageLoadingTimeout: any;

    descriptionVisible: boolean = false;
    loadTopAnimationOnly: boolean = false;

    futureSubmitMessage = null;
    showWorkflowNextStepMessage = false;
    showWorkflowSkipMessage = false;

    registerMode = false;
    registerRole = "";
    forgotPassword = false;
    confirmPassword = false;

    areYouSureInProgress = false;
    submitInProgress = false;

    reloadSubscription: Subscription;

    @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;

    constructor(
        public route: ActivatedRoute,
        public content: ContentService,
        public router: Router,
        public sanitizer: DomSanitizer,
        public dialog: MatDialog,
        public location: Location,
        public cdr: ChangeDetectorRef,
        public titleService: Title,
        public auth: AuthService,
        public nav: NavService,
        public i3v: I3VService,
        public workflow: WorkflowService,
        public app: AppComponent,
        public appIdService: AppidService,
        public http: HttpClient,
        public theme: ThemeService,
        public buttonService: ButtonService,
    ) { }

    ngOnInit(): void {

        // Call the asynchronous function to get the appID and when it returns it then call the loadTheme to get the correct css for the current app ID
        // The appID was loaded in the app.module.ts, so get it here to load it into the compoenents
        this.appIdService.appID$.pipe(take(1)).subscribe((appID) => {
            this.appID = appID;
            this.themeID = this.appIdService.GUIthemeID;
            this.theme.loadTheme(this.themeID);

            this.updateFavicon(appID);
        });

        let authToken = localStorage.getItem('token');

        if (authToken == null) {
            this.registerMode = true;
        }

		// This can be used for any asynchronous process to call any "action", but for now is only used for timeout,
		//    which will call the logout action.
        this.auth.actionResponse$.subscribe((action: any) => {
            if (action) {
                // Delegate the handling to the same handler that the app uses for other PageActionResponses
                this.handleActionResponse(action);
            }
        });

        this.route.queryParams.subscribe(async urlParams => {
            this.showPageSpinner();

            // When the NavSourceV1 is defined, it means the request is coming from V1.
            if (urlParams['NavSourceV1'] !== undefined) {
                localStorage.setItem('NavSourcev1', 'yes');
                localStorage.setItem('V1SID', urlParams['sid']);
                localStorage.setItem('V1OrgID', urlParams['org_id']);
                localStorage.setItem('V1PageID', urlParams['page_id']);
                localStorage.setItem('V1UserID', urlParams['V1UserID']);

                if (urlParams["FirstTimeFromV1"]) {

                    // Get a JSON string of the routes currently in the router cache
                    const oldRoutes = JSON.stringify(
                        this.router.config.map(route => ({
                            path: route.path,
                            nav: route.data?.nav,
                            page: route.data?.page
                        }))
                    );
                    
                    // Build the routes for this role.
                    await firstValueFrom(
                        this.nav.updateNavs(null, Number(urlParams['role_id']), urlParams['sid'])
                    );

                    // Get a JSON string of the new router cache that were just updated
                    const newRoutes = JSON.stringify(
                        this.router.config.map(route => ({
                            path: route.path,
                            nav: route.data?.nav,
                            page: route.data?.page
                        }))
                    );

                    // If there the router cache was changed:
                    // 1) User had routes for a different role 
                    // 2) User made a change within the app that would cause different navs to show (EX: In LOT turning Surname on/off shows or hides Applicant -> Surname Option nav)
                    if (oldRoutes !== newRoutes) {

                        // Find the route matching the incoming NavID in the routes that was just created.
                        const targetRoute = this.router.config.find(route => {
                            return route.data && route.data.nav == urlParams['NavID'];
                        });

                        // Redirect to the matching route while preserving exact same query params
                        this.router.navigate([targetRoute.path], {
                            queryParams: urlParams
                        });
                        return;
                    }
                }
            }

            // When we find an Individual, we want to keep his ID
            if (urlParams["IndividualPersonID"]) {
                localStorage.setItem("IndividualPersonID", urlParams["IndividualPersonID"]);
            }

            //"reset" local variables to avoid weirdness
            this.page = null;
            this.pageID = null;
            this.navID = null;
            this.pageParams = null;
            this.errorText = "";
            this.reloadTableSubject = new Subject<void>();
            this.descriptionVisible = false;
            this.showWorkflowNextStepMessage = false;
            this.showWorkflowSkipMessage = false;
            this.pageParams = this.buildParameters(urlParams);


            // if the routes object does not exist, then that means they are an unauth person, so get unauth navs
            if (localStorage.getItem("routes") == null) {
                //unauthenticated navigation will be loaded.
                // Clear the existing navigation items for unauthenticated users.
                this.nav.clearNavs().subscribe(
                    (data) => { },
                );
            }

            // We only want to know the first nav with a page when we are not authorized and it is the first time the app is opened.
            if (window.location.pathname === '/auth/login') {
                this.nav.updateNavs(this.auth.getToken(), this.auth.getRole()).subscribe(
                    (response) => {
                        const firstNavWithPage = this.findFirstNavWithPage(response["navs"] || []);

                        const routes = JSON.parse(localStorage.getItem('routes') || '[]');

                        // Find the saved path in local storage that matches the first nav with a page.
                        const route = routes.find(r => (r.data?.nav == firstNavWithPage?.id));
                        const firstPath = route?.path;

                        // Without a landing path there is nothing to redirect to, and replacing the
                        // location with "/undefined" would bounce back through the '**' redirect to
                        // this same page forever, leaving the outlet empty.
                        if (!firstPath) {
                            console.error("No navigable landing page found for this role");
                            this.errorText = "No navigable landing page found for this role";
                            return;
                        }

                        window.location.replace(`/${firstPath}`);
                    }
                );
            }

            // urlParams["page"]     → Standard V2 navigation. 
            // urlParams["page_id"]  → V1 integration / redirects. 
            this.pageID = urlParams["page"] ?? urlParams["page_id"];

            this.navID = this.providedNavID != null ? this.providedNavID : this.route.snapshot.data.nav;
            
            // front-end double check that token is valid (will be done on back end too)
            this.content.getPage(
                this.appID,
                this.navID,
                this.pageID,
                this.pageParams,
                localStorage.getItem('token') != null,
                localStorage.getItem('NavSourcev1'),
                localStorage.getItem('V1SID'),
                localStorage.getItem('V1OrgID')).subscribe(
                    async (data: Page | PageActionResponse) => {

                        // no data from back-end so serious problems (usually for development)
                        if (data == null) {
                            console.error("Get page returned null response");
                            this.errorText = "Get page returned null response";
                            return;
                        }

						// User clicked a link, button or icon that triggered a PageActionResponse.
                        if (this.instanceOfPageAction(data)) {
                            let pageAction: PageActionResponse = data;
                            this.handleActionResponse(pageAction);
                        } 
						
						// Standard onload of a page, so set the page data to the response. Maybe user clicked a Nav or submit and reloads.
						else {

                            // Data is the response we receive from the v2 backend and is the common JS object.
                            this.page = data;

                            this.titleService.setTitle(data.Title);
                            if (this.pageID == null) this.pageID = data.PageID;

                            if (this.futureSubmitMessage != null) this.page.SubmitMessage = this.futureSubmitMessage;

                            //update 11/16/22, the login component can now set the submit message via a url param,
                            //so we'll need to set that.
                            if (urlParams["msg"]) {
                                this.page.SubmitMessage = urlParams["msg"];
                            }

                            //debug information in console.
                            console.warn("Page: " + this.page.PageID + ", Nav: " + this.navID);
                            if (this.workflow.isInWorkFlow()) {
                                //if we're in workflow mode, download the submit message for this page if applicable
                                //will also determine if we're supposed to show the "click next" text.
                                let workflowMessageData = await this.workflow.getMessage(this.page.PageID).toPromise();

                                if (workflowMessageData) {
                                    if (workflowMessageData.submitMessageContent) this.page.SubmitMessage = workflowMessageData.submitMessageContent;
                                    if (workflowMessageData.showContinueText) this.showWorkflowNextStepMessage = workflowMessageData.showContinueText;
                                    if (workflowMessageData.showSkipText) this.showWorkflowSkipMessage = workflowMessageData.showSkipText;
                                }
                            }
                            
                        this.futureSubmitMessage = null;
                        if (this.pageLoadingTimeout) clearTimeout(this.pageLoadingTimeout);
                        this.pageLoading = false;
                        this.triggerLoading(false);
                    }
                },
                (error: any) => {
                    if (error.status == 404) {
                        console.error("page " + this.pageID + " not present in RADMAP");
                        this.errorText = "No associated Page class found in CoreService: nav id " + this.navID;
                    } else if (error.status == 500) {
                        this.errorText = error.error;
                    }
                },
            );

            // PageID 854 is the Job Processing page 
            // this.pageID is set when coming from a V2 page, and urlParams["page_id"] is set when coming from a V1 page
            if (this.pageID == 854 || urlParams["page_id"] == 854) {

                /*
                This is a special page that needs to be reloaded every 7 seconds because the user is waiting for a job to complete.
                The pages description will be updated with the jobs current status whenever it reloads.
                During the OnLoad of the page in the backend, when the job is completed it send a redirect PageActionResponse.
                */
                this.reloadSubscription = interval(7000).subscribe(
                    () => window.location.reload()
                );
            }
        });
    }

    instanceOfPageAction(object: any): object is PageActionResponse {
        return 'action' in object;
    }

	// Function called when user clicks app dropdown from header (header-base.component.ts). It calls the BE to get redirection info for V1 or V2.
	// In Superstructure bc redirect to V1 is handled in this file.
    onAppChange(newAppID) {
        
        this.auth.changeApp(
            this.appID,
            this.navID,
            newAppID,
            localStorage.getItem('NavSourcev1'),
            localStorage.getItem('V1SID'),
            localStorage.getItem('V1OrgID'),
            localStorage.getItem('V1PageID'),
            localStorage.getItem('V1UserID')).subscribe((data: any) => {

                if (data.action == 'redirect_to_v1') {
                    this.handleActionResponse(data);
                }

				// Not a V1 app, so go to V2 app. Not tested yet.
                this.auth.setOrgAndRole(data.org_id, data.newRoleID);
                this.auth.saveToken(data.token);
                
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                }
                    
            }, (error: any) => {
                console.error('Failed to change app:', error);
        });
    }	

    showPageSpinner(): void {
        this.pageLoadingTimeout = setTimeout(() => {
            this.pageLoading = true;
            this.triggerLoading(true);
        }, 300);
    }

    updateFavicon(AppID: number) {
        const faviconUrl = `assets/${AppID}.ico`;
        let link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = faviconUrl;

        const head = document.getElementsByTagName('head')[0];
        const existing = document.querySelector("link[rel*='icon']");
        if (existing) {
            head.removeChild(existing);
        }
        head.appendChild(link);
    }

    getDescription() {

        if (this.page.Description !== null) {
            const rawHtml = this.page.Description; // Assuming this.page.Description contains the HTML content

            // Sanitize HTML content to make it safe for rendering
            const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(rawHtml);

            return sanitizedHtml;
        }

        return null;
    }

    getMoreDescription() {
        return this.sanitizer.bypassSecurityTrustHtml(this.page.MoreDescription);
    }

    toggleDescription(): void {
        this.descriptionVisible = !this.descriptionVisible;
    }

    triggerLoading(activate: boolean): void {
        this.loadTopAnimationOnly = activate;
        this.cdr.detectChanges();
        if (!activate) this.submitInProgress = false;
    }

    buildParameters(urlParams: Params): PageParam[] {
        let pageParams: PageParam[] = [];
        for (let paramKey in urlParams) {
            pageParams.push({
                Name: paramKey,
                Type: "string",
                CurrentValue: urlParams[paramKey]
            });
        }

        return pageParams;
    }

    handleButtonLink(type: string, label: string, link: string): void {

        if (type == "link") {
            
            //check if link is just applying a "page" parameter
            if (link.indexOf("page=") > -1) {

                let baseUrl = this.router.url.split('?')[0];
                let currentParams = new URLSearchParams(this.router.url.split('?')[1]);

                // Get all the params from the link that was clicked.
                let linkParams = new URLSearchParams(link.substring(1)); 
                
                // Replace or add the parameters from the link to the current URL parameters.
                // E.j: page_id=123 to page_id=456 or adding a new parameter like page_id=123&user_id=789
                linkParams.forEach((value, key) => {
                    currentParams.set(key, value);
                });
                
                let finalUrl = baseUrl + '?' + currentParams.toString();
                this.router.navigateByUrl(finalUrl);
            }

        } else if (type == "callback") {
            this.content.submitButtonClick(this.navID, this.pageID, label, this.pageParams).subscribe({
                next: (data: PageActionResponse) => this.handleActionResponse(data),
                error: (error: any) => {
                    console.error(error);
                    this.errorText = error.error;
                },
            });
        }
    }

    // Finds the first navigation item that has a page associated with it.
    private findFirstNavWithPage(navs: any[]): any | null {
        for (const nav of navs) {
            if (nav.hasPage) {
                return nav;
            }

            // Only give up on this branch, not on the remaining siblings: a leading nav whose
            // subtree has no page must not stop the search for one that does.
            const found = this.findFirstNavWithPage(nav.children || []);
            if (found) {
                return found;
            }
        }

        return null;
    }

    formValidAndSubmitted(values: Record<number | string, string>): void {

		// Prevents double clicking of submit button.
        if (this.submitInProgress) return;

        if (this.pageID == 15) {
            const lockUntil = localStorage.getItem('loginLockUntil');
            if (lockUntil) {
                const lockTime = new Date(parseInt(lockUntil));
                const now = new Date();
                
                // User has waited long enough due to lock out, so reset attempts and allow login attempt.
                if (now >= lockTime) {
                    this.resetLoginAttempts();
                } else {
                    const timeStr = lockTime.toLocaleString('en-US', { 
                        hour: 'numeric', 
                        minute: 'numeric', 
                        hour12: true 
                    });
                    
                    this.page.SubmitMessage = `You have been locked out of your account until ${timeStr}.`;
                    return;
                }
            }
        }

        this.submitInProgress = true;
        this.triggerLoading(true);

        //SPECIAL CASE: credit card tokenization must be handled client side.
        if (this.page.PageResources && this.page.PageResources["I3V_PUBLIC"]) {
            let i3vKey = this.page.PageResources["I3V_PUBLIC"];
            let i3vAccount = this.page.PageResources["I3V_ACCOUNT"];
            let i3vURL = this.page.PageResources["I3V_URL"];
            this.i3v.tokenizeCreditCard(i3vURL, i3vAccount, i3vKey, values[159], values[160], values[161], values[162]).subscribe({
                next: (data: any) => {
                    if (data.ResultCode == 0) {
                        this.pageParams.push({
                            Name: "token",
                            CurrentValue: data.Token
                        });

                        this.pageParams.push({
                            Name: "Last4",
                            CurrentValue: data.Last4
                        })

                        //remove 159, 160, 161, and 162 from values
                        for (let i = 159; i <= 162; i++) {
                            delete values[i];
                        }

                        this.content.submitPage(this.navID, this.pageID, values, this.pageParams, localStorage.getItem('token') != null).subscribe(
                            (data: PageActionResponse) => {
                                this.handleActionResponse(data);
                                this.triggerLoading(false);
                            },
                            (error: any) => {
                                console.error(error);
                            },
                        );
                    } else {
                        this.page.SubmitMessage = "Your card failed to verify. Please try again.";
                        this.triggerLoading(false);
                    }
                },
                error: (error: any) => {
                    console.error(error);
                }
            });
        }

        // This is not a credit card page
        else {

            //if registrationRole present, add it to pageparams
            if (this.registerRole != null) {
                this.pageParams.push({
                    Name: "role",
                    CurrentValue: this.registerRole
                });
            }

            // Display the loading animation on form submission
            this.showPageSpinner();

            this.content.submitPage(this.navID, this.pageID, values, this.pageParams, localStorage.getItem('token') != null).subscribe(
                (data: PageActionResponse) => {
                    this.handleActionResponse(data);
                    if (this.pageLoadingTimeout) clearTimeout(this.pageLoadingTimeout);
                    this.pageLoading = false;
                    this.triggerLoading(false);
                },
                (error: any) => {
                    console.error(error);
                },
            );
        }
    }

    markWorkflowStep(): void {
        this.triggerLoading(true);
        this.workflow.completeStep(this.pageID).subscribe({
            next: (data: PageActionResponse) => {
                this.handleActionResponse(data);
                this.triggerLoading(false);
            },
            error: (error: any) => {
                console.error(error);
            }
        });
    }

    skipWorkflowStep(): void {
        this.triggerLoading(true);
        this.workflow.skipStep(this.pageID).subscribe({
            next: (data: PageActionResponse) => {
                this.handleActionResponse(data);
                this.triggerLoading(false);
            },
            error: (error: any) => {
                console.error(error);
            }
        });
    }

    triggerSupportLink(): void {
        this.handleActionResponse({
            action: "redirect",
            pageID: 330,
            options: []
        });
    }

    // Real 15 login is successful (Fake 15 login is in auth.service.ts > login)
    async login(action): Promise<void> {
        this.auth.setOrgAndRole(action.newOrg, action.newRole);
        this.auth.saveToken(action.token);

        let roleID = this.auth.getRole();
        let targetNav = action.next;

        //283 or 287 should also use workflowservice to get which page to go to
        this.http.get<boolean>(environment.urls.core + `/auth/isRegistrationRole?role_id=${roleID}`).pipe(
            switchMap(isRegistrationRole => {
                if (isRegistrationRole) {
                    return this.workflow.initialLogin();
                } else {
                    this.workflow.disableWorkflow();
                    return of(null); // Returns a dummy observable if not a registration role
                }
            })
        ).subscribe(workflowData => {
            if (workflowData) {
                targetNav = workflowData["page"];
            }

            // Determine the URL to redirect the user based on targetNav, which may represent either a page ID or a navID
            // First, we try to match targetNav as a page ID (used when the user is in a NavRegStep flow)
            // If no match is found, we assume targetNav is a nav (used in standard login flows) and try to match that instead

            // grab the navs for the role
            this.nav.updateNavs(this.auth.getToken(), this.auth.getRole()).subscribe(
                (routeLoaded) => {
                    let url = null;

                    // get the url to send the user based on the page returned by back-end
                    url = this.router.config.find(route => {
                        return route.data && route.data.navPage == targetNav;
                    });

                    if (url) url = url.path;

                    // no url if back-end returns a nav instead
                    if (!url) {
                        url = this.router.config.find(route => route.data?.nav === targetNav).path;
                    }

                    if (action.msg) this.futureSubmitMessage = action.msg;

                    this.router.navigateByUrl(url);
                },
                (error) => {
                    console.error(error);
                }
            );
        });
    }

    private resetLoginAttempts(): void {
        localStorage.removeItem('loginAttempts');
        localStorage.removeItem('loginLockUntil');
    }

	// This is the main handler for all responses from the back-end.
    handleActionResponse(action: PageActionResponse): void {
        if (action == null) {
            console.error("action response is null");
            return;
        }

        switch (action.action) {

			// Reloads just the table and not the whole page.
            case "reload_table":
                this.reloadTableSubject.next(action.options);
                this.page.SubmitMessage = action.message;
                break;

			// Deprecated - no longer used. Can test deleting it.
            case "reload_table_with_existing_data":
                // if the reload_table_with_existing_data reload response has a message, then assign it to the submit message
                this.page.SubmitMessage = action.message;
                this.reloadTableWithDataSubject.next(action.options);
                break;
            
			// Use nav in redirect for unauth users. Nav must have a main page associated with it. 
			// Purpose is for unauth page used with different navs (ex: login for staff and individual)
			case "redirect_nav":
                let targetPageWithNav = this.router.config.find(route => {
                    return route.data &&
                        route.data.nav &&
                        route.data.nav == action.navID &&
                        route.data.hasPage &&
                        route.data.navPage == action.pageID;
                });
                if (targetPageWithNav) {

                    this.router.navigate([targetPageWithNav.path], {
                        queryParams: {
                            msg: action.message
                        }
                    });
                }
                else {
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: this.route.snapshot.queryParams,
                        queryParamsHandling: "merge"
                    });
                }
                break;

			// Redirects the user to V1 with hidden variables passed through a form post.	
            case "redirect_to_v1":
                //remove v1 related local storage before redirecting the user to v1.
                localStorage.removeItem('NavSourcev1');
                localStorage.removeItem('V1SID');
                localStorage.removeItem('V1OrgID');
                localStorage.removeItem('V1UserID');

                // Create a form element to submit so that the user can be redirected to v1
                // The reason we want to do this instead of just changing the window location is so that we can send through hidden variables as well 
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = action.v1Url;

                // Go through the hidden variables and add them to the form
                for (let key in action.options["HiddenVariables"]) {
                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = key;
                    hiddenField.value = action.options["HiddenVariables"][key];
                    form.appendChild(hiddenField);
                }

                // If there is a message (submit_message) then add it as a hidden variable 
                // because if it is long then we do not want to put it in the url
                if (action.message) {
                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = 'submit_msg';
                    hiddenField.value = action.message;
                    form.appendChild(hiddenField);
                }

                document.body.appendChild(form);
                form.submit();
                break;

			// Standard redirect (an else to redirect_nav)
            case "redirect":
                // check to see if the shouldUpdateOrg option exists, and if it is, update the org cookie in localStorage
                if (action.options["shouldUpdateOrg"]) {
                    this.auth.setOrgAndRole(action.options["orgID"], parseInt(localStorage.getItem("role")));
                }

                //clear everything from params by creating a param dictionary with existing params and setting all to null
                this.route.queryParams.pipe(first()).subscribe(x => {
                    let params: Params = {};
                    for (let key in x) {
                        params[key] = null;
                    }

                    params["page_id"] = action.pageID;
                    for (let paramKey in action.options["additionalParams"]) {
                        params[paramKey] = action.options["additionalParams"][paramKey];
                    }

                    //submit message from the v2 backend
                    if (action.message) params["msg"] = action.message;

                    //looks like temp variable.
                    this.futureSubmitMessage = action.message;

                    const NavSourcev1 = localStorage.getItem('NavSourcev1');

                    // If we are originally from V1, then send through the following variables as well so that the auth logic works
                    if (NavSourcev1) {
                        params['NavSourceV1'] = NavSourcev1;
                        params['sid'] = localStorage.getItem('V1SID');
                        params['org_id'] = localStorage.getItem('V1OrgID');
                        params['V1UserID'] = localStorage.getItem('V1UserID');
                    }

                    if (action.pageID == 9999) {
                        this.router.navigateByUrl("/auth/login?msg=" + action.message);
                        return;
                    }

                    if (this.scrollContainer) {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                
                    const NavIDFromParams = action.options?.["additionalParams"]?.["NavID"];

                    //inspect the router config to determine if there is already a nav page with the target pageID
                    let targetNav = this.router.config.find(route => {

                        // The normal param navID can't be used bc when there is more than one possible navIDs for this page,
                        //   it will only get the first one.
                        if (NavIDFromParams) {
                            return route.data && route.data.nav == NavIDFromParams;
                        }

                        // If we have a NavID, we will keep it
                        else if (action.navID) {
                            return route.data.nav == action.navID;
                        }
                        // Search for a route that has data, that has a page and that matches the pageID of the action.
                        else {
                            return route.data && route.data.hasPage && route.data.navPage == action.pageID;
                        }
                    });

                    if (targetNav) {
                        this.router.navigate([targetNav.path], {
                            queryParams: params
                        });
                    } else {
                        this.router.navigate([], {
                            relativeTo: this.route,
                            queryParams: params,
                            queryParamsHandling: "merge"
                        });
                    }
                });
                break;

			// Does not reload the page. It populates the message and scrolls to top.
            case "message":
                this.page.SubmitMessage = action.message;
                if (this.scrollContainer) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
                break;

			// Displays message in a popup dialog.
            case "popup":
                const popupDialog = this.dialog.open(PopupComponent, {
                    data: {
                        message: action.options["message"],
                    }
                });
                break;

			// Generic pop-up associated with the page the user is on for Yes/No type questions.
			// Not used to validate the submission of a form (ResubmitPage lower down). 
			// Instead used with it's own CallBack methods for Yes and No.
            case "areyousure":
                const areyousureDialog = this.dialog.open(AreyousureComponent, {
                    data: {
                        question: action.options["question"],
                        yesAnswer: action.options["yesAnswer"],
                        noAnswer: action.options["noAnswer"],
                    }
                });
                areyousureDialog.afterClosed().subscribe(x => {
                    
                    // x will be True if user selected the Yes Answer, or false if user selected the No Answer (labels may differ from Yes/No)
                    if (x && !this.areYouSureInProgress) {
                        this.areYouSureInProgress = true;
                        this.showPageSpinner();

                        this.content.submitAreYouSure(action.options["elementID"], action.options["type"], action.options["clickedYesCallBack"], action.options["additionalParams"], action.options["V1_Params"]).subscribe({
                            next: (data: PageActionResponse) => {
                                this.handleActionResponse(data);
                                this.areYouSureInProgress = false;
                                if (this.pageLoadingTimeout) clearTimeout(this.pageLoadingTimeout);
                                this.pageLoading = false;
                                this.triggerLoading(false)
                            },
                            error: (error: any) => {
                                this.areYouSureInProgress = false;
                                console.error(error);
                            }
                        });
                    }
                    // Else if user selected No Answer and there is a clickedNoCallBack
                    else if (action.options['clickedNoCallBack'] && !this.areYouSureInProgress) {
                        this.areYouSureInProgress = true;

                        this.content.submitAreYouSure(action.options["elementID"], action.options["type"], action.options["clickedNoCallBack"], action.options["additionalParams"], action.options["V1_Params"]).subscribe({
                            next: (data: PageActionResponse) => {
                                this.areYouSureInProgress = false;
                                this.handleActionResponse(data);
                            },
                            error: (error: any) => {
                                this.areYouSureInProgress = false;
                                console.error(error);
                            }
                        });
                    }
                });
                break;

			// Angular special function to go back.
            case "go_back":
                this.location.back();
                break;

			// Only used for submission of icons in tables from V1 dispalyed in V2.
            case "submitExisting":
                //add actions.options to pageParams
                for (let paramKey in action.options) {
                    this.pageParams.push({
                        Name: paramKey,
                        Type: "string",
                        CurrentValue: action.options[paramKey]
                    });
                }

                
                this.showPageSpinner();
                
                this.content.submitPage(this.navID, this.pageID, {}, this.pageParams).subscribe(
                    (data: PageActionResponse) => {                        
                        if (this.reloadTableSubject != null) this.reloadTableSubject.next(action.options);
                        this.handleActionResponse(data);

                        if (this.pageLoadingTimeout) clearTimeout(this.pageLoadingTimeout);
                        this.pageLoading = false;
                        this.triggerLoading(false);
                    }
                );
                break;

			// Submitting a form by clicking the submit button is FormValidatedAndSubmitted, 
			//   but this is used for resubmitting a page from other BE locations, like an Are You Sure pop-up.
            case "ResubmitPage":

                for (let paramKey in action.options["Parameters"]) {
                    this.pageParams.push({
                        Name: paramKey,
                        CurrentValue: action.options["Parameters"][paramKey]
                    });
                }

                this.showPageSpinner();

                this.content.submitPage(this.navID, this.pageID, action.options["FormData"], this.pageParams, localStorage.getItem('token') != null).subscribe(
                    (data: PageActionResponse) => {
                        this.handleActionResponse(data);
                        if (this.pageLoadingTimeout) clearTimeout(this.pageLoadingTimeout);
                        this.pageLoading = false;
                        this.triggerLoading(false);
                    },
                    (error: any) => {
                        console.error(error);
                    }
                );
                break;

			// Fires when login is successful.
            case "login":
                this.login(action.options);
                this.resetLoginAttempts();
                break;

            case "FailedLoginAttempt":
                this.page.SubmitMessage = action.message;

				/* We don't want to make it obvious to the user who is savvy enough to check local storage how many times an attempt has been made,
				*   bc they can change that number to reduce their number of attempts and keep trying.
				* Instead, we will store the seconds as 2 digits at the time of each attempt as a cumulative string in local storage.
				* By dividing the string length by 2, we can get the number of attempts.
				* This way from the user's perspective, they just see a random sting of numbers and can't easily identify how the * system determines the number of unsuccesful login attempts.*/
                const now = new Date();
                const currentSeconds = now.getSeconds().toString().padStart(2, '0');
                
                let attemptsString = localStorage.getItem('loginAttempts') || '';
                attemptsString += currentSeconds;
                
                const numAttempts = attemptsString.length / 2;
                
                if (numAttempts >= 5) {
                    const lockTime = new Date();
                    lockTime.setMinutes(lockTime.getMinutes() + 15);
                    localStorage.setItem('loginLockUntil', lockTime.getTime().toString());
                    localStorage.setItem('loginAttempts', '');
                    
                    const timeStr = lockTime.toLocaleString('en-US', { 
                        hour: 'numeric', 
                        minute: 'numeric', 
                        hour12: true 
                    });
                    this.page.SubmitMessage = `You have been locked out of your account until ${timeStr}.`;
                } else {
                    localStorage.setItem('loginAttempts', attemptsString);
                }
                break;

			// It doesn't appear that this is being used.
            case "register":
                this.login(action.options);
                break;
            
			// When user clicks 'logout' nav or when session times out.
            case "logout":

                // Call the auth service logout() function to remove the token and other data from local storage.
                this.auth.logout();

                // Call the clearNavs() function to clear the nav routes and then reset them to be the unauth nav routes.
                firstValueFrom(this.nav.clearNavs())
                .then(() => { // success callback
                        
                        // Use the passed in Login Nav ID to find the correct nav route to redirect to.
                        // NOTE: Login Nav ID is calculated on backend using the user's current role.
                        let targetNav = this.router.config.find(route => {
                            return route.data.nav == action.options["LoginNavID"]
                        });

                        let params: Params = {};

                        if (action.message) {
                            params["msg"] = action.message
                        }

                        params["org_id"] = localStorage.getItem('org');

                        this.router.navigate([targetNav.path], {
                            queryParams: params
                        });
                    },
                    (error) => {
                        console.error("Error during logout:", error);
                    }
                );
                break;
            default:
                console.error("unknown action: " + action.action);
                console.warn(action);
        }

    }
}
